import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadMoreButton: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	loadMoreButton: {
		defaultMessage: 'Load new activity',

		id: 'home.tab-container.load-more-button',
		description: 'Text of a button on the your work page which loads the latest data',
	},
});
export default messages;
